module.exports = __webpack_public_path__ + "static/together_img1_m@2x-25959b80deecc9fd21f8221405aa6464.png";